<template>
    <div class="creator--edit" style="height:100%;">
        <creator-header v-if="plugin && versions" :plugin="plugin" :versions="versions"></creator-header>
        <placeholder v-else :type="'creator.header'"></placeholder>
        <div v-if="plugin && versions" class="container">
            <div class="creator">
                <creator-navigation :id="plugin_id"></creator-navigation>
                <div class="right">
                    <div class="plugin__header">
                        <h2 @click="updatePreviousVersions(plugin_id)">{{$t('page.creator_edit.package')}}</h2>
                    </div>
                    <div class="version__grid" v-if="versions">
                        <div class="version__entry">
                            <h3 class="version__status">
                                {{getStatusText(versions.latest.publish_status)}}
                                <p v-if="versions.latest.text && versions.latest.status == 3" class="declined--info">
                                    <b>{{$t('page.listing.moderator_cited')}}</b><br/>
                                    {{versions.latest.text}}
                                </p>
                                <svg v-if="versions.latest.publish_status == 1" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="icons-/-filled-/-clock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M11,6 C10.4477153,6 10,6.44771525 10,7 L10,7 L10,13.5 L10.0077914,13.6254379 C10.069498,14.1185148 10.4901987,14.5 11,14.5 L11,14.5 L17.5,14.5 L17.6254379,14.4922086 C18.1185148,14.430502 18.5,14.0098013 18.5,13.5 L18.5,13.5 L18.4922086,13.3745621 C18.430502,12.8814852 18.0098013,12.5 17.5,12.5 L17.5,12.5 L12.0002334,12.4997666 L12,7 L11.9922086,6.87456212 C11.930502,6.38148518 11.5098013,6 11,6 Z" id="Combined-Shape" fill="#F7B55C"></path>
                                    </g>
                                </svg>
                                <svg v-if="versions.latest.publish_status == 2" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="icons-/-filled-/-checkmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350"></path>
                                    </g>
                                </svg>
                                <svg v-if="versions.latest.publish_status == 3" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="icons-/-filled-/-delete" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <path d="M12,0 C18.6281739,0 24,5.37182609 24,12 C24,18.6281739 18.6281739,24 12,24 C5.37182609,24 0,18.6281739 0,12 C0,5.37182609 5.37182609,0 12,0 Z M8.11289944,6.70970461 C7.72060824,6.40467972 7.15337718,6.43240926 6.79289322,6.79289322 C6.40236893,7.18341751 6.40236893,7.81658249 6.79289322,8.20710678 L6.79289322,8.20710678 L10.585,12 L6.79289322,15.7928932 L6.70970461,15.8871006 C6.40467972,16.2793918 6.43240926,16.8466228 6.79289322,17.2071068 C7.18341751,17.5976311 7.81658249,17.5976311 8.20710678,17.2071068 L8.20710678,17.2071068 L12,13.415 L15.7928932,17.2071068 L15.8871006,17.2902954 C16.2793918,17.5953203 16.8466228,17.5675907 17.2071068,17.2071068 C17.5976311,16.8165825 17.5976311,16.1834175 17.2071068,15.7928932 L17.2071068,15.7928932 L13.415,12 L17.2071068,8.20710678 L17.2902954,8.11289944 C17.5953203,7.72060824 17.5675907,7.15337718 17.2071068,6.79289322 C16.8165825,6.40236893 16.1834175,6.40236893 15.7928932,6.79289322 L15.7928932,6.79289322 L12,10.585 L8.20710678,6.79289322 Z" id="Combined-Shape" fill="#E73246" fill-rule="nonzero"></path>
                                    </g>
                                </svg>
                            </h3>
                            <table class="version__meta">
                                <tr>
                                    <td>{{$t('page.creator_edit.version')}}</td>
                                    <td>{{versions.latest.version_number}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('page.creator_edit.uploaded')}}</td>
                                    <td>{{getDate(versions.latest.uploaded)}}</td>
                                </tr>
                            </table>
                            <a v-if="versions.latest.publish_status == 0 || versions.latest.publish_status == 3" @click="updateVersionStatus('requestPublish', versions.latest)" class="version__link link">{{$t('listing.submit')}}</a>
                        </div>
                        <template v-for="version in versions.all">
                            <div class="version__entry" v-if="version.id != versions.latest.id && version.publish_status != 0" :key="version.id">
                                <h3 class="version__status">
                                    {{getStatusText(version.publish_status)}}
                                    <p v-if="version.text && versions.latest.publish_status == 3" class="declined--info">
                                        <b>{{$t('page.listing.moderator_cited')}}</b><br/>
                                        {{version.text}}
                                    </p>
                                    <svg v-if="version.publish_status == 1" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="icons-/-filled-/-clock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M11,6 C10.4477153,6 10,6.44771525 10,7 L10,7 L10,13.5 L10.0077914,13.6254379 C10.069498,14.1185148 10.4901987,14.5 11,14.5 L11,14.5 L17.5,14.5 L17.6254379,14.4922086 C18.1185148,14.430502 18.5,14.0098013 18.5,13.5 L18.5,13.5 L18.4922086,13.3745621 C18.430502,12.8814852 18.0098013,12.5 17.5,12.5 L17.5,12.5 L12.0002334,12.4997666 L12,7 L11.9922086,6.87456212 C11.930502,6.38148518 11.5098013,6 11,6 Z" id="Combined-Shape" fill="#F7B55C"></path>
                                        </g>
                                    </svg>
                                    <svg v-if="version.publish_status == 2" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="icons-/-filled-/-checkmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350"></path>
                                        </g>
                                    </svg>
                                    <svg v-if="version.publish_status == 3" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="icons-/-filled-/-delete" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <path d="M12,0 C18.6281739,0 24,5.37182609 24,12 C24,18.6281739 18.6281739,24 12,24 C5.37182609,24 0,18.6281739 0,12 C0,5.37182609 5.37182609,0 12,0 Z M8.11289944,6.70970461 C7.72060824,6.40467972 7.15337718,6.43240926 6.79289322,6.79289322 C6.40236893,7.18341751 6.40236893,7.81658249 6.79289322,8.20710678 L6.79289322,8.20710678 L10.585,12 L6.79289322,15.7928932 L6.70970461,15.8871006 C6.40467972,16.2793918 6.43240926,16.8466228 6.79289322,17.2071068 C7.18341751,17.5976311 7.81658249,17.5976311 8.20710678,17.2071068 L8.20710678,17.2071068 L12,13.415 L15.7928932,17.2071068 L15.8871006,17.2902954 C16.2793918,17.5953203 16.8466228,17.5675907 17.2071068,17.2071068 C17.5976311,16.8165825 17.5976311,16.1834175 17.2071068,15.7928932 L17.2071068,15.7928932 L13.415,12 L17.2071068,8.20710678 L17.2902954,8.11289944 C17.5953203,7.72060824 17.5675907,7.15337718 17.2071068,6.79289322 C16.8165825,6.40236893 16.1834175,6.40236893 15.7928932,6.79289322 L15.7928932,6.79289322 L12,10.585 L8.20710678,6.79289322 Z" id="Combined-Shape" fill="#E73246" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                </h3>
                                <table class="version__meta">
                                    <tr>
                                        <td>{{$t('page.creator_edit.version')}}</td>
                                        <td>{{version.version_number}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('page.creator_edit.uploaded')}}</td>
                                        <td>{{getDate(version.uploaded)}}</td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>
                    <btn @click="showOverlay()" :class="'btn--ghost btn--save'" :text="$t('page.creator_edit.upload_new_version')" />
                    <div v-if="versions && versions.latest_public && Object.keys(versions.latest_public).length > 0" class="plugin__visibility">
                        <h2>{{$t('page.creator_edit.visibility')}}</h2>
                        <ul class="visibility__settings">
                            <li @click="toggleVisibility(1)">
                                <input v-if="plugin.published != 1" type="radio" name="visibility" />
                                <span v-else class="checkbox--fake radio">
                                    <div class="bullet">&nbsp;</div>
                                </span>
                                <label>
                                    <b>{{$t('status.public')}}</b>
                                    <span class="meta">{{$t('page.creator_edit.public_info')}}</span>
                                </label>
                            </li>
                            <li @click="toggleVisibility(0)">
                                <input v-if="plugin.published == 1" type="radio" name="visibility" />
                                <span v-else class="checkbox--fake radio">
                                    <div class="bullet">&nbsp;</div>
                                </span>
                                <label>
                                    <b>{{$t('status.private')}}</b>
                                    <span class="meta">{{$t('page.creator_edit.private_info')}}</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <placeholder v-else :type="'page.creator_listing'"></placeholder>
        <div v-if="overlayVisible" class="overlay__container" @click.self="hideOverlay()">
            <div class="overlay__box">
                <div class="create__new step--1">
                    <h2>{{$t('page.creator_edit.new_version')}}</h2>
                    <p class="label">{{$t('page.creator_edit.version_number')}}</p>
                    <div class="version__wrapper">
                        <textarea v-model="versionNumber" class="input--textarea" rows="3" :placeholder="version.major + '.' + version.minor + '.' + version.number"></textarea>
                        <p class="error">{{versionError}}</p>
                    </div>
                    <p class="label">{{$t('page.creator_edit.changelog')}}</p>
                    <div class="changelog__box">
                        <textarea v-model="changelog" class="input--textarea" rows="3"></textarea>
                        <p class="error">{{changelogError}}</p>
                    </div>
                    <p class="info">{{$t('page.creator.upload_text')}}</p>
                    <div class="upload__box">
                        <template v-if="files && files.length > 0">
                            <div class="upload__entry" v-for="(file, index) in files" :key="file">
                                <span class="title">{{file.name}}</span>
                                <span @click="removeFile(index)" class="remove">{{$t('page.creator.remove')}}</span>
                            </div>
                        </template>
                        <div v-if="!files || files.length == 0" class="upload__box--entry">
                            <input @change="handleFileChange()" type="file" id="files" ref="files" name="files" accept="text/xml">
                            <label for="files" class="background">
                                <label for="files" class="button">{{$t('page.creator.upload_select')}}</label>
                            </label>
                            <p class="error">{{fileError}}</p>
                        </div>
                        <div class="upload__navigation">
                            <btn @click="uploadFiles()" :class="['btn--small']" :text="$t('page.creator.next')" />
                        </div>
                    </div>
                </div>
                <div class="close__overlay" @click="hideOverlay()">
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CreatorNavigation from '@/components/CreatorNavigation.vue';
import CreatorHeader from '@/components/CreatorHeader.vue';
import Placeholder from '@/components/Placeholder.vue';
import Btn from '@/components/Button.vue';

export default{
    components: {
        CreatorNavigation,
        CreatorHeader,
        Placeholder,
        Btn
    },
    data() {
        return {
            changelog: '',
            plugin: null,
            versions: null,
            currentVersion: '1.0.0',
            versionNumber: '',
            fileObject: [],
            files: null,
            version: {
                major: 1,
                minor: 0,
                number: 0,
            },
            versionError: '',
            changelogError: '',
            fileError: '',
            status: 0,
            overlayVisible: false,
            plugin_id: window.location.href.split('/')[5].substring(window.location.href.split('/')[5].lastIndexOf('-') + 1),
        }
    },
    methods: {
        toggleVisibility(int) {
            let formData = new FormData();
            formData.append('plugin_id', this.plugin_id);
            formData.append('visibility', int);
            axios.post( 'https://api.library.loxone.com/updatePluginVisibility',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    crossDomain: true,
                    withCredentials: true,
                },
            ).then(response => {
                this.plugin.published = int;
                if(int == 1) {
                    this.$store.dispatch('addNotification', {title: this.$t('notification.plugin_publish_successfull'), text: this.$t('notification.plugin_publish_successfull_txt'), type: 'success'});
                } else if (int == 0){
                    this.$store.dispatch('addNotification', {title: this.$t('notification.plugin_unpublish_successfull'), text: this.$t('notification.plugin_unpublish_successfull_txt'), type: 'success'});
                } else {
                    this.$store.dispatch('addNotification', {title: this.$t('notification.error'), text: this.$t('notification.error_txt'), type: 'error'});
                }
            })

        },

        langChange(event, data){
            data['language'] = event;
        },

        hideOverlay() {
            this.overlayVisible = false;
        },

        showOverlay() {
            this.overlayVisible = true;
        },

        handleFileChange() {
            this.files = Array.from(this.$refs.files.files);
        },

        removeFile(index) {
            this.files.splice(index, 1);
        },

        getDate(date) {
            return date;
        },

        checkBeforeSave() {
            var versionCheck = true;
            var changelogCheck = true
            var fileCheck = true;

            this.versionError = '';
            this.changelogError = '';
            this.fileError = '';
            var n = this.versionNumber.replace(/[^0-9.]/g, '').replace('..', '.');

            if(n.split('.').length >= 1) {
                var n0 = n.split('.')[0];
                if(n0.length > 2) {
                    n0 = n0.substring(0, 2);

                    n = n0;
                }
            }

            if(n.split('.').length >= 2) {
                var n1 = n.split('.')[1];
                if(n1.length > 2) {
                    n1 = n1.substring(0, 2);
                    n = n0 + '.' + n1;
                }
            }

            if(n.split('.').length >= 3) {
                var n2 = n.split('.')[2];
                if(n2.length > 2) {
                    n2 = n2.substring(0, 3);
                    n = n0 + '.' + n1 + '.' + n2;
                }
            }

            if(n.split('.').length > 3) {
                n =  n0 + '.' + n1 + '.' + n2;
            }
            
            if(n.split('.').length < 3 || n.split('.')[2] == "") {
                this.versionError = this.$t('page.listing.update.error.version_format');
                versionCheck = false;
            }else {
                if(!((parseInt(n0) > this.version.major) || (parseInt(n0) == this.version.major && parseInt(n1) > this.version.minor) || (parseInt(n0) == this.version.major && parseInt(n1) == this.version.minor && parseInt(n2) > (this.version.number - 1)))) {
                    this.versionError = this.$t('page.listing.update.error.version_number');
                    versionCheck = false;
                }
            }
            
            this.versionNumber = n;

            //Changelog
            if(this.changelog.length < 10) {
                this.changelogError = 'The changelog must have a minimum length of 10 characters.';
                changelogCheck = false;
            }

             if(!this.files) {
                this.fileError = 'You must select a file!';
                fileCheck = false;
             }

            return (versionCheck && changelogCheck && fileCheck);
        },

        uploadFiles() {
            var valid = this.checkBeforeSave();
            if(valid) {
                if(this.versionNumber == '' || this.versionNumber == null) {
                    this.versionError = this.$t('page.listing.update.error.version_format');
                    return;
                }
                let formData = new FormData();
                formData.append('version_no', this.versionNumber);
                formData.append('plugin_id', this.plugin_id);
                formData.append('changelog', this.changelog);
                for( var i = 0; i < this.files.length; i++ ){
                    let file = this.files[i];
                    formData.append('files[' + i + ']', file);
                }

                axios.post( 'https://api.library.loxone.com/upgradePluginVersion',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        crossDomain: true,
                        withCredentials: true,
                    },
                ).then(response => {
                    console.log(response);
                    this.overlayVisible = false;
                    this.$store.dispatch('addNotification', {title: this.$t('notification.version_upgrade_successfull'), text: this.$t('notification.version_upgrade_successfull_txt'), type: 'success'});
                    this.updatePreviousVersions(this.plugin_id, response.data.version_id);
                    this.reload_versions();

                })
                .catch(function(e){
                    this.$store.dispatch('addNotification', {title: this.$t('notification.version_upgrade_failed'), text: this.$t('notification.version_upgrade_failed'), type: 'error'});
                });
            }
        },

        updatePreviousVersions(plugin_id, version_id) {
            let formData = new FormData();
            formData.append('plugin_id', plugin_id);
            formData.append('version_id', version_id);
             axios.post( 'https://api.library.loxone.com/resetPreviousPluginVersions',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        crossDomain: true,
                        withCredentials: true,
                    },
                ).then(response => {
                })
        },

        reload_versions() {
            var pluginInfo = new FormData();
            pluginInfo.append('plugin', this.plugin_id);
            pluginInfo.append('plugin_id', this.plugin_id);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadPluginVersions',
                data: pluginInfo,
            }).then(response => {
                this.versions = response.data
            });
        },

        updateVersionStatus(task, version) {
            this.$store.dispatch('addNotification', {title: this.$t('notification.version_publish_request'), text: this.$t('notification.version_publish_request_txt'), type: 'info'});
            var data = new FormData();
            data.append('task', task);
            data.append('company_name', this.$store.state.userData.company_displayname);
            data.append('company_id', this.$store.state.userData.company_id);
            data.append('plugin_name', this.plugin.name);
            data.append('plugin_id', this.plugin.plugin_id);
            data.append('version_number', version.version_number);
            data.append('version_id', version.id);
            data.append('user_id', this.$store.state.userData.user_id);
            
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/updateVersionStatus',
                data: data,
            }).then(response => {
                location.reload();
            });
        },

        getStatusText(status) {
            switch(status) {
                case 0:
                    return this.$t('status.draft');			// Draft
                case 1:
                    return this.$t('status.review');		// In Review
                case 2:
                    return this.$t('status.published');     // Published
                case 3:
                    return this.$t('status.declined');      //  Declined
                case 9:
                    return this.$t('status.archive');      //  Archive
            }
        },

        getStatusClass(status) {
            switch(status) {
                case 0:
                    return 'status--draft';         // Draft
                case 1:
                    return 'status--review';        // In Review
                case 2:
                    return 'status--published';     // Published - Public
                case 4:
                    return 'status--declined';      // Declined
            }
        },
    },

    created() {
        var pluginInfo = new FormData();
        pluginInfo.append('plugin', this.plugin_id);
        pluginInfo.append('plugin_id', this.plugin_id);
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginDetail',
            data: pluginInfo,
        }).then(response => (this.plugin = response.data));

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginVersions',
            data: pluginInfo,
        }).then(response => {
            this.versions = response.data
        });

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginVersion',
            data: pluginInfo,
        }).then(response => {
            this.version.major = parseInt(response.data.split('.')[0]);
            this.version.minor = parseInt(response.data.split('.')[1]);
            this.version.number = parseInt(response.data.split('.')[2]) + 1;
            this.currentVersion = this.version.major + "." + this.version.minor + "." + this.version.number;
        });

    }
}
</script>

<style scoped lang="scss">
    @import '../scss/utilities/variables';
    @import '../scss/pages/creator';

    .plugin__visibility h2{
        margin-top: 30px !important;
    }
</style>
